/**
 * RequireGoal – แสดง SetGoalForm ก่อนถ้าผู้ใช้ยังไม่มีเป้าหมาย
 * ใช้ครอบ route หลัก (dashboard) เพื่อ redirect ไป /set-goal เมื่อไม่มี current goal
 */

import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { goalsService } from '@/services/goals.service';
import { LoadingScreen } from '@/components/ui/loading-screen';

export function RequireGoal({ children }: { children: React.ReactNode }) {
  const { data: currentGoal, isLoading } = useQuery({
    queryKey: ['goals', 'current'],
    queryFn: () => goalsService.getCurrentGoal(),
  });

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!currentGoal) {
    return <Navigate to="/set-goal" replace />;
  }

  return <>{children}</>;
}
